<template>
  <el-checkbox v-model="booleanValue">{{ title }}</el-checkbox>
</template>
<script>
export default {
  props: {
    defaultValue: Boolean,
    title: String,
    config: Boolean
  },
  computed: {
    booleanValue: {
      get() {
        return this.config ?? this.defaultValue
      },
      set(newVal) {
        this.$emit('update:config', newVal)
      }
    }
  }
}
</script>